import axios from 'axios'
import router from '@/router'
import { Message } from '@/components/message/message.js'
//let base_url = 'http://rtk-exam.3wchina.net/zuul/'; 
let base_url = 'https://rtk-exam.3wchina.net/zuul/'; 
//let base_url = 'http://student.exam.aopa.org.cn/zuul/'; 
//let base_url = 'http://exam.166.com/zuul/'; 
let isMes = false;
export function setIsMes () {
  isMes = false
}
//请求拦截器
// axios.interceptors.request.use(config => {
//   // if(sessionStorage.getItem('userMsg')) {
//     // config.params.access_token = JSON.parse(sessionStorage.getItem('userMsg')).access_token;
//   // }
//   if (config.params) {
//     config.params['clientId'] = 'examinerweb:' + localStorage.getItem('clientIP')
//     if(sessionStorage.getItem('userMsg') && JSON.parse(sessionStorage.getItem('userMsg'))['accessToken']) {
//       config.params['accessToken'] = JSON.parse(sessionStorage.getItem('userMsg')).accessToken
//     }
//   } else {
//     config.params = {
//       clientId: 'examinerweb:' + localStorage.getItem('clientIP')
//     };
//     if(sessionStorage.getItem('userMsg') && JSON.parse(sessionStorage.getItem('userMsg'))['accessToken']) {
//       config.params['accessToken'] = JSON.parse(sessionStorage.getItem('userMsg')).accessToken
//     }
//   }
//   return config
// }, error => {
//   return Promise.reject(error)
// });
// axios.interceptors.response.use(response => {
//   return response
// }, error => {
//   if(error['response'] && (error.response.status == '401' || error.response.status == '601')) {
//     if(!sessionStorage.getItem('userMsg') || !JSON.parse(sessionStorage.getItem('userMsg'))['accessToken']) {
//       if (router.name !== 'login') {
//         router.push({
//           path: '/login'
//         });
//         if(!isMes) {
//           isMes = true;
//           Message({message:'请先登录!',type:"Error"})
//         }
//       }
//     }else {
//       refreshToken()
//     }
//   }
//   return Promise.reject(error)
// })
/**
 * 刷新token方法
 */
function refToken (token) {
  return axios.post(`${base_url}esauth/refreshToken`,null,{params:{refreshToken: token}})
}

let  a=2;
if(a==1){
  refreshToken ()
}
function refreshToken () {
  let json = JSON.parse(sessionStorage.getItem('userMsg'))
  returnResult(refToken(json['refreshToken']),(type, res) => {
    if(type) {
      json.refreshToken = res.data.refreshToken;
      json.accessToken = res.data.accessToken;
      sessionStorage.setItem('userMsg', JSON.stringify(json))
      router.go(0)
    }else {
      sessionStorage.removeItem('userMsg');
      if (router.name !== 'login') {
        router.push({
          path: '/login'
        });
        if(!isMes) {
          isMes = true;
          Message({message:'请重新登录!',type:"Error"});
        }
      }
    }
  })
}
export function setLogin(usn, pas) {//登录接口
  return axios.post(`${base_url}esauth/login`,null,{params:{username: usn, password: pas}})
}
export function getAudiosToken() {//获取百度API token接口
  return axios.get(`${base_url}esadmin/baidu`)
}
export function isExaminer() {
  return axios.get(`${base_url}esadmin/examiner/isExaminer`)
}
export function getExaminee(ids, file, examineeId) {//获取考生信息
  return axios.get(`${base_url}esadmin/monitor/getByIdNo`,{
    params:{
      idNo: ids,
      fieldNumber: file,
      examineeId: examineeId,
      timesNow: new Date().getTime()
    }
  })
}
export function getExamineeOptions(ids, file) {//获取考生可开考科目
  return axios.get(`${base_url}esadmin/monitor/getExamineeOptions`,{
    params:{
      idNo: ids,
      fieldNumber: file,
      timesNow: new Date().getTime()
    }
  })
}
export function getField(number) {//获取考场信息
  return axios.get(`${base_url}esadmin/fields/findByExamNumber`,{
    params: {
      examNumber: number,
      timesNow: new Date().getTime()
    }
  })
}
export default function returnResult(fn, callback) {//公用接口返回值相关
  fn.then(res => {
    if(res.status === 200 && res.data.code === 0) {
      if(callback) {
        callback (true, res.data)
      }
    }else {
      if(callback) {
        callback (false, res.data)
      }
    }
  }).catch(error => {
    if( error['response']) {
      if(callback) {
        callback (false, error.response.data)
      }
    }else {
      if(callback) {
        callback (false, error)
      }
    }
  })
}
export function handleJudge (data) {//判断当前条件
  let res = true;
  try {
    data.forEach(item => {
      if(item['type'] === 'String') {
        if(!item['value']) {
          res = false;
          if(item['errorMsg']) {
            Message(item['errorMsg'])
          }
          item.break=new Error("StopIteration")
        }
      }
    });
  }catch(e){
    if(e.message==="foreach is not defined") {
      // console.log("跳出来了?");//
      return;
    }else throw e;
  }
  return res;
}



// WEBPACK FOOTER //
// ./src/interface/controller.js
